import { Outlet, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import NotFound from "../pages/NotFound/NotFound";

function PrivateRoutesAdmin() {
  const { pathname } = useLocation();

  const token = localStorage.getItem("token");
  if (!token) return <NotFound />;

  let user;
  try {
    user = jwtDecode(token)?.apirest?.objeto;
  } catch {
    return <NotFound />;
  }

  const puesto = Number(user?.puesto);

  const roleSegment = {
    1: "/admin/consultoras",
    2: "/admin/empresas",
    3: "/admin/empleados",
  };

  if (pathname === "/admin" || pathname === "/admin/") {
    return <Outlet />;
  }

  const allowed = pathname.startsWith(roleSegment[puesto] ?? "");

  return allowed ? <Outlet /> : <NotFound />;
}

export default PrivateRoutesAdmin;